import { Routes } from '@angular/router';
import { priceDashboardResolver } from '../core/resolvers/price-dashboard.resolver';
import { transactionDashboardResolver } from '../core/resolvers/transaction-dashboard.resolver';

export const routes: Routes = [
  {
    path: 'price',
    loadChildren: () => import('./price.routes').then((routes) => routes.PRICE_ROUTES),
    resolve: {
      priceListPreReq: priceDashboardResolver
    }
  },
  {
    path: 'transaction',
    loadChildren: () => import('./transaction.routes').then((routes) => routes.TRANSACTION_ROUTES),
    resolve: {
      roles: transactionDashboardResolver
    }
  },
  {
    path: 'no-records',
    loadComponent: () =>
      import('../core/components/no-records-page/no-records-page.component').then((m) => m.NoRecordsPageComponent)
  },
  {
    path: '',
    redirectTo: 'transaction',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'transaction'
  }
];
